import { useLocation } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { Logo } from "./Logo";

export function Footer() {
  const { go } = useApp();
  const location = useLocation();
  if (location.pathname.startsWith("/personalize")) return null;
  return (
    <footer className="hb-footer">
      <div className="wrap">
        <div className="foot-grid">
          <div>
            <a
              className="hb-logo"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                go({ name: "home" });
              }}
            >
              <Logo size={28} />
              hushberry
            </a>
            <div className="foot-tag" style={{ marginTop: 18 }}>
              Personalized Books For Every Kid.
            </div>
          </div>
          <div>
            <h4>Shop</h4>
            <ul>
              <li>
                <a href="#" onClick={(e) => { e.preventDefault(); go({ name: "detail", bookId: "lunar" }); }}>
                  Name Celebrates Chinese New Year
                </a>
              </li>
              <li>
                <a href="#" onClick={(e) => { e.preventDefault(); go({ name: "detail", bookId: "hanukkah" }); }}>
                  Name Celebrates Hanukkah
                </a>
              </li>
              <li>
                <a href="#" onClick={(e) => { e.preventDefault(); go({ name: "detail", bookId: "diwali" }); }}>
                  Name Celebrates Diwali
                </a>
              </li>
              <li>
                <a href="#" onClick={(e) => { e.preventDefault(); go({ name: "detail", bookId: "friends" }); }}>
                  All My Friends Are Beautiful
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4>Help</h4>
            <ul>
              <li><a href="#">Questions &amp; Answers</a></li>
              <li><a href="#">Privacy Policy</a></li>
              <li><a href="#">Contact Us</a></li>
            </ul>
          </div>
          <div>
            <h4>Company</h4>
            <ul>
              <li><a href="#">Our Story</a></li>
              <li><a href="#">Press</a></li>
            </ul>
          </div>
        </div>
        <div className="foot-bottom">
          <span>© 2026 HUSHBERRY BOOKS · AUSTIN · NEW YORK</span>
          <span>PRINTED ON FSC-CERTIFIED PAPER</span>
        </div>
      </div>
    </footer>
  );
}
